import {SelectionModel} from '@angular/cdk/collections';
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatStepper} from '@angular/material/stepper';
import {MatTableDataSource} from '@angular/material/table';
import {SenderInfo} from '../../../../models/SenderInfo';
import {Student} from '../../../../models/student';
import {CommonService} from '../../../../services/common.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-form-users-assignment',
  templateUrl: './form-users-assignment.component.html',
  styleUrls: ['./form-users-assignment.component.scss']
})
export class FormUsersAssignmentComponent implements OnInit {
  //#region class members
  @ViewChild('stepper', {static: false}) stepper: MatStepper;
  affirmations: MatTableDataSource<any>;
  announcements: MatTableDataSource<any>;
  consents: MatTableDataSource<any>;
  customForms: MatTableDataSource<any>;
  displayColumns = ['select', 'title', 'date_created', 'created_by'];
  editorStyle: any;
  forms: MatTableDataSource<any>;
  formsLoading = false;
  isLinear = true;
  isLoading = false;
  isNotificationLoading: boolean;
  isRequestLoading: boolean;
  loading: boolean;
  message: string;
  notifyParents: any;
  public selection: SelectionModel<any>;
  searchValue: string;
  selectedAffirmations: SelectionModel<any>;
  selectedAnnouncements: SelectionModel<any>;
  selectedConsents: SelectionModel<any>;
  selectedCustomForms: SelectionModel<any>;
  selectedSender: SenderInfo;
  senderAddress = '';
  senderName = '';
  senders: SenderInfo[] = [];
  students: Student[];
  subject = '';
  tempForms = [];
  publishToParents: false;
  users: any[] = [];
  constructor(private commonService: CommonService,
              public confirmDialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public toastMessagesService: ToastMessagesService,
              public dialog: MatDialogRef<FormUsersAssignmentComponent>) {
    this.searchValue = '';
    this.selection = new SelectionModel<any>(true, []);
    this.editorStyle = {width: '100%', height: '400px'};
    this.message = '';
    this.isNotificationLoading = false;
    this.users = data.users;
    this.loading = false;
    this.isRequestLoading = false;
  }

  async ngOnInit() {
    try {
      this.formsLoading = true;
      this.notifyParents = false;
      await this.initializeForms();
      await this.initializeCustomForms();
      await this.initSenders();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(`${e.message}`);
    } finally {
      this.formsLoading = false;
    }
  }

  async initSenders() {
    try {
      const request = await this.commonService.getList('college/email-senders');
      this.senders = request.object;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e);
      throw e;
    }
  }
  async initializeCustomForms() {
    try {
      const formsRequest = await this.commonService.getList('forms/custom');
      for (const object of formsRequest.object) {
        object.has_two_factor = object.has_two_factor ? object.isGDPR === 1 ? 'NAI' : 'OXI' : 'ΟΧΙ';
      }
      this.forms = new MatTableDataSource<any>(formsRequest.object);

      this.consents = new MatTableDataSource<any>(formsRequest.object.filter(form => form.form_type_id === 1));
      this.affirmations =  new MatTableDataSource<any>(formsRequest.object.filter(form => form.form_type_id === 2));
      // this.customForms = new MatTableDataSource<any>(formsRequest.object);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φέρουμε τις προσαρμοσμένες δηλώσεις');
      throw e;
    }
  }
  async initializeForms() {
    try {
      const formsRequest = await this.commonService.getList('forms/forms');
      this.announcements =  new MatTableDataSource<any>(formsRequest.object.filter(form => form.form_type_id === 3));
      this.tempForms = formsRequest.object;
    } catch (e) {
      console.log(e.message);
      throw e;
    }
  }


  searchConsents(value) {
    this.consents.filter = value.trim().toLowerCase();
  }

  searchAffirmations(value) {
    this.affirmations.filter = value.trim().toLowerCase();
  }

  searchCustomForms(value) {
    console.log(value);
    this.customForms.filter = value.trim().toLowerCase();
  }

  searchAnnouncements(value) {
    this.announcements.filter = value.trim().toLowerCase();
  }

  //#region checkboxes in table
  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;

    // @ts-ignore
    const numRows = this.forms.data.length;

    return numSelected === numRows;
  }

  public masterToggle(): void {
    // @ts-ignore
    this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach((row) => this.selection.select(row));
  }

  //#endregion

  //#region Stepper previous & next
  async next() {
    if (this.stepper.selectedIndex === 0) {
      this.stepper.next();
    } else if (this.stepper.selectedIndex === 1) {
      // this.stepper.next();
      await this.sendNotification();
    }
  }

  async sendNotification() {

    const notificationsList = [];

    for (const user of this.users) {
      for (const form of this.selection.selected) {
        const notificationModel = {
          userId: user.id,
          form_unique_id: form.unique_id,
          title: form.title,
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          telephone: user.telephone
        };
        notificationsList.push(notificationModel);
      }
    }
    const style = `<style>table,tr,th,td {border: 1px solid black;}</style>`;

    const insertModel = {
      notifications: notificationsList,
      message: `${style}${this.message}`,
      sender: {
        address: this.selectedSender.address,
        name: this.selectedSender.name
      },
      subject: this.subject
    };


    const confirm = this.confirmDialog.open(ConfirmDialogComponent, {
      data: {
        title: `Δημοσίευση δηλώσεων`,
        message: `Είστε σίγουροι ότι θέλετε να δημοσιεύσετε τις επιλεγμένες δηλώσεις?`
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        this.dialog.updateSize('300px', '100px');
        this.dialog.updatePosition({ bottom: '50px', left: '25px' });
        this.isRequestLoading = true;
        this.isNotificationLoading = true;
        this.isLoading = true;
        try {
          await this.commonService.insertItem('staff/publish-form', insertModel);
          this.toastMessagesService.toastMessages(`Η δημοσίευση ολοκληρώθηκε με επιτυχία`);
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
          this.isLoading = false;
          this.isNotificationLoading = false;
          this.dialog.close();
          this.isRequestLoading = false;
        }
      }
    });
  }

  previous() {
    this.stepper.previous();
  }

  proceedStep() {
    return this.selection.selected.length === 0;
  }

  //#endregion

  close() {
    this.dialog.close();
  }

  validMessage() {

    if (!this.selectedSender) {
      return true;
    } else {
      if (this.message) {
        return this.message.length === 0;
      } else {
        return true;
      }
    }
  }

  updateMessage($event) {
    this.message = $event;
  }
}
